import React, {useContext} from 'react';

import {
    BrowseCourseBadgesContext,
    BrowseCourseBadgeHandler,
    BrowseCourse,
    getCourseBadgeFromType,
    COURSE_BADGE_NEW,
    COURSE_BADGE_HOT_AND_NEW,
    COURSE_BADGE_UPDATED_RECENTLY,
} from '@udemy/browse-course';
import {CourseBuyable} from '@udemy/shopping';

import styles from './shopping-item.module.less';
import {ActionSupportedLayoutsProps} from './types';

function updatedRecently(updatedDateString: string) {
    if (!updatedDateString) {
        return false;
    }
    const ninetyDaysAgo = Date.now() - 1000 * 60 * 60 * 24 * 90;
    return new Date(updatedDateString).getTime() > ninetyDaysAgo;
}

interface BadgesProps {
    buyable: CourseBuyable;
    actionsLayout?: ActionSupportedLayoutsProps;
}

export const Badges: React.FC<BadgesProps> = ({buyable, actionsLayout}) => {
    const badgeData = buyable.badges && buyable.badges.length > 0 ? buyable.badges[0] : null;
    const CourseBadgeComponentWithoutSubsDiff =
        badgeData && getCourseBadgeFromType(badgeData.badge_family);

    const {browseBadgeHandlerOptions} = useContext(BrowseCourseBadgesContext);
    const badgeHandler = new BrowseCourseBadgeHandler(
        buyable as unknown as BrowseCourse,
        browseBadgeHandlerOptions,
    );
    const finalCourseBadgeComponent =
        actionsLayout === 'vertical'
            ? CourseBadgeComponentWithoutSubsDiff && <CourseBadgeComponentWithoutSubsDiff />
            : badgeHandler.getBadgeComponents()[0] ?? null;

    const UpdatedRecentlyBadgeComponent = finalCourseBadgeComponent
        ? null
        : updatedRecently(buyable.last_update_date ?? Date.now().toString()) &&
          ![COURSE_BADGE_NEW, COURSE_BADGE_HOT_AND_NEW].includes(badgeData?.badge_family ?? '') &&
          getCourseBadgeFromType(COURSE_BADGE_UPDATED_RECENTLY);

    return finalCourseBadgeComponent || UpdatedRecentlyBadgeComponent ? (
        <div className={styles.badges}>
            {finalCourseBadgeComponent}
            {UpdatedRecentlyBadgeComponent && <UpdatedRecentlyBadgeComponent />}
        </div>
    ) : null;
};
